import { useState } from "react";
import { ReactComponent as SearchIcon } from "Assets/Search.svg";
import ClassNames from "Helpers/Common";

export default function SearchBar({
  onFocus,
  onSearch,
  onKeyDown,
  searchQuery,
  searchResults,
  setSearchQuery,
  label = "Search",
  setSearchResults,
  filterKey = false,
  isFiltered = false,
  placeholder = "Search",
  setIsSearchFieldFocused,
  isHealthConditionSearch = false,
}) {
  const [showSuggestions, setShowSuggestions] = useState(false);
  console.log(
    "SearchBar Rendered with searchResults: ",
    searchResults,
    onFocus,
    onSearch,
    onKeyDown,
    searchQuery,
    searchResults,
    setSearchQuery,
    (label = "Search"),
    setSearchResults,
    (filterKey = false),
    (isFiltered = false),
    (placeholder = "Search"),
    setIsSearchFieldFocused,
  );
  return (
    <div className="w-full">
      <label htmlFor={label} className="sr-only">
        Search
      </label>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
          <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </div>
        <input
          id="search"
          name="search"
          value={searchQuery}
          onChange={({ target: { value } }) => {
            setSearchQuery(value);
            setShowSuggestions(true);
          }}
          className="block w-full bg-white border border-gray-300 rounded-md py-1 pl-10  pr-10 text-sm placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          placeholder={placeholder}
          // "text", not "search": WebKit renders its own clear affordance for
          // type=search only when the field has content, which would sit next
          // to the always-visible button below.
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setShowSuggestions(false);
            }
            onKeyDown?.(e);
          }}
          onFocus={() => {
            setShowSuggestions?.(true);
            setIsSearchFieldFocused?.(true);
            onFocus?.();
          }}
          onBlur={() => {
            setShowSuggestions(false);
            setIsSearchFieldFocused?.(false);
          }}
        />
        {/* Always rendered, empty field or not (per Omer): the control stays
            in one place instead of appearing and shifting the layout.
            onMouseDown rather than onClick — the input's onBlur fires first
            and would tear down the suggestion list before a click landed. */}
        <button
          type="button"
          aria-label="Clear search"
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
          onMouseDown={(e) => {
            e.preventDefault();
            setSearchQuery("");
            setSearchResults?.([]);
            setShowSuggestions(false);
          }}
        >
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-gray-400 hover:bg-gray-500">
            <svg
              className="h-3 w-3 text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </span>
        </button>
        {showSuggestions && searchResults?.length > 0 && (
          <div
            className={ClassNames(
              "absolute mt-1 flex flex-col gap-2 bg-white shadow-xl z-20 p-2  w-64 h-44 overflow-y-auto",
              isHealthConditionSearch ? "w-full" : "w-64",
            )}
          >
            {searchResults?.map((user, index) => (
              <div
                key={index}
                className="text-sm cursor-pointer  hover:bg-gray-200"
                onMouseDown={() => {
                  onSearch?.(isHealthConditionSearch ? user : user?.id);
                  setSearchResults([]);
                }}
              >
                {isHealthConditionSearch ? (
                  user?.name + "   (" + `${user?.ICDCode ?? "no-code"}` + ")"
                ) : (
                  <>
                    {!isFiltered && user?.username}
                    {isFiltered && filterKey.includes("userName") && `${user?.username ?? ""}`}
                    {isFiltered && filterKey.includes("phoneNumber") && `${user?.phoneNumber ?? ""}`}

                    {isFiltered && filterKey.includes("id") && `${user?.cognitoId ?? ""}`}
                    {isFiltered &&
                      (filterKey.includes("firstName") || filterKey.includes("lastName")) &&
                      `${user?.firstName + " " + user?.lastName}`}
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
